import { render } from "./ModalSimple.vue?vue&type=template&id=52357706"
import script from "./ModalSimple.vue?vue&type=script&lang=js"
export * from "./ModalSimple.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__